import React from 'react';
import LegalLayout from './LegalLayout';

const PrivacyPolicy = () => {
  return (
    <LegalLayout>
      <div className="container-standard px-4 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="flex justify-center items-center mb-6">
            <a href="/" className="text-primary-accent font-bold hover:underline text-lg">
                 ← Volver al Inicio
              </a>
            </div>
           <div className="text-center mb-4">
            <h1 className="text-display font-bold text-primary-dark">Política de Privacidad</h1>
          </div>
          <p className="text-center text-gray-600 mb-8">Última actualización: Febrero 2026</p>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">1. Información que recopilamos</h2>
            <p className="mb-4">
              Recopilamos información personal cuando usted nos la proporciona directamente a través de nuestro formulario de contacto, incluyendo nombre, correo electrónico y mensaje.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">2. Uso de la información</h2>
            <p className="mb-4">
              La información recopilada se utiliza para:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Responder a sus consultas y solicitudes</li>
              <li>Mejorar nuestro servicio al cliente</li>
              <li>Enviar correos electrónicos periódicos relacionados con su solicitud o intereses empresariales</li>
              <li>Realizar análisis estadísticos para mejorar nuestros servicios</li>
            </ul>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">3. Protección de la información</h2>
            <p className="mb-4">
              Implementamos medidas de seguridad adecuadas para proteger contra el acceso no autorizado, alteración, divulgación o destrucción de su información personal. Esto incluye tanto medidas técnicas como físicas.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">4. Divulgación a terceros</h2>
            <p className="mb-4">
              No vendemos, comercializamos ni alquilamos su información personal a terceros. Podemos compartir información con proveedores de servicios de confianza que nos ayudan a operar nuestro sitio web, realizar negocios o servir a nuestros usuarios, siempre bajo acuerdos de confidencialidad.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">5. Enlaces de terceros</h2>
            <p className="mb-4">
              Nuestro sitio puede contener enlaces a sitios de terceros. No somos responsables de las prácticas de privacidad de estos sitios. Le recomendamos leer las políticas de privacidad de cada sitio que visite.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">6. Cookies y tecnologías similares</h2>
            <p className="mb-4">
              Utilizamos cookies para mejorar la funcionalidad de nuestro sitio web y comprender las preferencias de los visitantes. Puede configurar su navegador para rechazar todas las cookies o para indicar cuándo se envía una cookie.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">7. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</h2>
            <p className="mb-4">
              En cumplimiento con la Ley de Protección de Datos Personales (Ley N° 29733) y su Reglamento (Decreto Supremo N° 003-2013-JUS), usted tiene derecho a:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Solicitar información sobre sus datos personales que poseemos</li>
              <li>Rectificar datos personales incorrectos o incompletos</li>
              <li>Solicitar la eliminación de sus datos personales cuando ya no sean necesarios</li>
              <li>Oponerse al tratamiento de sus datos personales</li>
            </ul>
            <p className="mb-4">
              Para ejercer estos derechos, contáctenos a través de <a href="mailto:info@davidcorp-srl.com" className="text-primary-accent hover:underline">info@davidcorp-srl.com</a>
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">8. Seguridad de la información</h2>
            <p className="mb-4">
              Implementamos medidas de seguridad técnicas, administrativas y físicas para proteger su información personal contra pérdida, robo, uso indebido, acceso no autorizado, divulgación, alteración o destrucción.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">9. Retención de datos</h2>
            <p className="mb-4">
              Conservamos su información personal solo durante el tiempo necesario para cumplir con los fines para los cuales fueron recopilados, incluyendo cualquier período requerido por ley.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">10. Cambios a esta política</h2>
            <p className="mb-4">
              Podemos actualizar esta política de privacidad. Le notificaremos sobre cambios significativos a través de nuestro sitio web o por correo electrónico.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">11. Cumplimiento legal</h2>
            <p className="mb-4">
              Esta política de privacidad cumple con las disposiciones de la Ley N° 29733, Ley de Protección de Datos Personales, y demás normas complementarias y reglamentarias vigentes en el Perú.
            </p>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">12. Contacto</h2>
            <p className="mb-4">
              Si tiene preguntas sobre esta política de privacidad, contáctenos en:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="font-medium">DAVID CORPORATION S.R.L. - DAVIDCORP S.R.L.</p>
              <p>RUC: 20602434011</p>
              <p>491 Jr. Sta Cruz de Pachacutec, Los Olivos, Lima, Perú</p>
              <p>Email: <a href="mailto:info@davidcorp-srl.com" className="text-primary-accent hover:underline">info@davidcorp-srl.com</a></p>
              <p>Teléfono: <a href="tel:+51936776570" className="text-primary-accent hover:underline">+51 936776570</a></p>
            </div>
            
            <h2 className="text-subheading font-bold text-primary-dark mt-8 mb-4">13. Autoridad Nacional de Protección de Datos Personales</h2>
            <p className="mb-4">
              Si considera que sus derechos han sido vulnerados, puede presentar una queja ante la Autoridad Nacional de Protección de Datos Personales (ANPD) del Ministerio de Justicia y Derechos Humanos del Perú.
            </p>
          </div>
        </div>
      </div>
    </LegalLayout>
  );
};

export default PrivacyPolicy;